import './EventThankYouPage.css'

import React, { useState, useEffect } from 'react';
import { RiVerifiedBadgeFill } from "react-icons/ri";
import EventsListingCardSkeleton from './EventsListingCardSkeleton';
import EventsListingCard from './EventsListingCard';
import axios from 'axios';
import { Link } from 'react-router-dom';

const url = "https://partywitty.com/master/assets/uploads/";



// Mock data
const mainEvent = {
    id: 1,
    title: "Sitar Magic by Rishubh Rikhiram Sharma",
    image: "https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?w=400&h=200&fit=crop",
    date: "02 JUL",
    time: "7 PM",
    location: "Tagore Nagar Metro Station, CP, New Delhi",
    rating: 4.3,
    reviews: 2764,
    price: 1180,
    originalPrice: 1200
};

// Components
const SuccessMessage = () => (
    <div className="event-thank-you-success-message">
        <div className="event-thank-you-success-icon"><RiVerifiedBadgeFill size={70} /></div>
        <div className="event-thank-you-success-title">Thank you</div>
        <div className="event-thank-you-success-subtitle">
            <h6>Your reservation request is received successfully!</h6>
            <p>
                Please be patient while our experts check the place for
                available seating for you.
            </p>
        </div>
    </div>
);

const EventCard = ({ event }) => {
    return (
        <div className="event-thank-you-event-card">
            <EventsListingCard title={event?.name} date={event?.event_date} time={event?.event_time} rating={event?.rating} location={event?.cityName} distance={event?.distance} type={event?.categoryName} price={event?.min_price} image={url + event?.image} offer={event?.offer} eventid={event?.id} clubid={event?.club_id} isEventThankyou={true}/>
        </div>
    );
};

const Sidebar = () => {
    const [selectedAddOns, setSelectedAddOns] = useState([]);
    const [couponCode, setCouponCode] = useState('');

    const addOns = [
        { id: 'vip', label: '₹999', icon: '★', percent: 10 },
        { id: 'premium', label: '₹99-₹999', icon: '👥', percent: 20 },
        { id: 'deluxe', label: '₹999-₹1000', icon: '🎭', percent: 30 },
        { id: 'deluxeMax', label: '₹9999-₹10000', icon: '🎭', percent: 40 },
    ];

    const toggleAddOn = (id) => {
        setSelectedAddOns(prev =>
            prev.includes(id)
                ? prev.filter(item => item !== id)
                : [...prev, id]
        );
    };

    return (
        <div className="event-thank-you-sidebar">
            <div className="event-thank-you-sidebar-section">
                <h4 className="event-thank-you-sidebar-title">Recent Offers from Your Chosen Venue</h4>

                <div className="event-thank-you-sidebar-section">
                    <p className='event-thank-you-add-on-title'>Add on Offers</p>
                    <div className="event-thank-you-add-ons">
                        {addOns.map(addon => (
                            <button
                                key={addon.id}
                                className={`event-thank-you-add-on-btn ${selectedAddOns.includes(addon.id) ? 'active' : ''}`}
                                onClick={() => toggleAddOn(addon.id)}
                            >
                                {addon.label}
                                <p className='event-thank-you-add-on-percent'>{addon.percent}%</p>
                            </button>
                        ))}
                    </div>
                </div>

                <div className="event-thank-you-coupon-section">
                    <p style={{ fontSize: '14px', marginBottom: '10px' }}>Confirm Spend</p>
                    <div className="event-thank-you-coupon-input">
                        <input
                            type="text"
                            placeholder="Enter Amount "
                            value={couponCode}
                            onChange={(e) => setCouponCode(e.target.value)}
                        />
                    </div>

                    <div className="event-thank-you-price-breakdown">
                        <div className="event-thank-you-price-row">
                            <span>You can spend</span>
                            <span>₹15000 including @ <span>50% EXTRA</span></span>
                        </div>

                        <div className="event-thank-you-price-row total">
                            <span><input type="checkbox" /></span>
                            <span className="event-thank-you-savings">I agree to the Terms of Service and Privacy Policy. </span>
                        </div>
                    </div>

                    <div className='event-thank-you-secure-offer'>
                        <h3>₹1180</h3>
                        <button className="event-thank-you-secure-offer-btn">Secure my Offer</button>
                    </div>

                    <ul className="event-thank-you-offer-note">
                        <li>The upfront payment will be adjusted in your final bill at the venue. Terms apply.
                        </li>
                        <li>Pay ₹1,180 now to confirm and Pay the remaining ₹8,820 at the venue</li>
                    </ul>

                </div>
            </div>
        </div>
    );
};


const VenuesSection = ({ setSelectedEvent }) => {
    const [eventsData, setEventData] = useState([]);
    const [latitude, setLatitude] = useState(null);
    const [longitude, setLongitude] = useState(null);



    const fetchUpcomingEvents = async (lat, lng, date) => {
        try {
            const formData = new FormData();
            formData.append('latitude', lat);
            formData.append('longitude', lng);

            const response = await axios.post(
                'https://partywitty.com/master/APIs/ClubEvent/allEvents',
                formData
            );

            if (response.data.status === true) {
                setEventData(response.data.data);
            } else {
                console.warn('No events found:', response.data.msg);
                setEventData([]); // Clear if no events
            }
        } catch (error) {
            console.error('Error fetching upcoming events:', error);
            setEventData([]);
        }
    };

    useEffect(() => {
        if ('geolocation' in navigator) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    const { latitude, longitude } = position.coords;
                    const latStr = latitude.toString();
                    const lngStr = longitude.toString();

                    setLatitude(latStr);
                    setLongitude(lngStr);

                    fetchUpcomingEvents(latStr, lngStr,)
                },
                (error) => {
                    alert('Please enable Geo Location Service to find events in your locality.');
                    console.error('Error in finding location:', error);
                }
            );
        } else {
            console.error('Geolocation is not available in this browser.');
        }
    }, []);

    useEffect(() => {
        if (Array.isArray(eventsData) && eventsData.length > 0) {
            setSelectedEvent(eventsData[0]);
        }
    }, [eventsData]);



    function generateClubUrl(clubName, cityName, areaName, title) {
        const format = (str) => (str ? str.trim().replace(/\s+/g, "_").toLowerCase() : "");

        return `/event/${format(clubName)}-${format(cityName)}-${format(areaName)}/${format(title)}`;
    }

    return (
        <div className="event-thank-you-swap-section">
            <h2 className="event-thank-you-swap-title">Swap Now & Save More</h2>

            <div className="event-thank-you-filter-bar">
                <h4>Explore other venues offering exclusive discounts on food & beverages.</h4>
                <span className='event-thank-you-filter-item'>Easily switch your event pass to a location that gives you more value — no extra cost, just better perks.</span>
            </div>

            <div className="event-thank-you-filter-bar-filter">
                <span className="event-thank-you-filter-item">Sort By:</span>
                <span className="event-thank-you-filter-item">Low to High</span>
                <span className="event-thank-you-filter-item">High to Low</span>
            </div>

            <div className="event-thank-you-venues-grid">
                {eventsData?.length === 0 ?
                    <>
                        {Array.from({ length: 6 }).map((_, index) => (
                            <EventsListingCardSkeleton key={index} />
                        ))}

                    </>
                    : (
                        eventsData.slice(0, 10).map((event, index) => (
                            <div
                                onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    setSelectedEvent(event);
                                }}
                                key={index}
                            >

                                <EventsListingCard title={event.name} date={event.event_date} time={event.event_time} rating={event.rating} location={event.cityName} distance={event.distance} type={event.categoryName} price={event.min_price} image={url + event.image} offer={event.offer} eventid={event.id} clubid={event.club_id}  />
                            </div>
                        )))}
            </div>

        </div>
    );
};


export default function EventThankYouPage() {
    const [selectedEevent, setSelectedEvent] = useState();
    return (
        <div className='event-thank-you-page-section'>
            <div className="event-thank-you-booking-container">

                <div className='event-thank-you-main-upper-section'>
                    <SuccessMessage />
                    <div className='event-thank-you-main-title'>
                        <h1>Your Selected Event Pass</h1>
                        <span>Skip Now</span>
                    </div>
                    <div className="event-thank-you-main-content">
                        <EventCard event={selectedEevent} />
                        <Sidebar />
                    </div>
                </div>

                <VenuesSection setSelectedEvent={setSelectedEvent} />
            </div>
        </div>
    )
}
